// @ts-check
import React from 'react';
import { CHAT_STATUS_MAP } from 'constants/index';
import PropTypes from 'prop-types';
import { List, ListItem, Box, Typography } from '@material-ui/core';
import Drawer from '../Drawer';
import { CheckIcon } from '../Icons';
import ChatStatusIndicator from '../ChatStatusIndicator';

const ChatStatusDrawer = ({ classes, open, status, onStatusChange, close }) => {
  /**
   * @param {boolean} newStatus
   */
  const getStatusChangeHandler = (newStatus) => () => {
    onStatusChange(newStatus);
    close();
  };

  return (
    <Drawer open={open} title="Chat Status" titleVariant="h4" onClose={close} withoutClose withoutDivider>
      <List>
        <ListItem className={classes.item} onClick={getStatusChangeHandler(true)}>
          <Box className={classes.title}>
            <ChatStatusIndicator status={CHAT_STATUS_MAP.AVAILABLE} classes={{ root: classes.indicator }} />
            <Typography variant="body1">Available</Typography>
          </Box>
          {status === CHAT_STATUS_MAP.AVAILABLE && <CheckIcon />}
        </ListItem>
        <ListItem className={classes.item} onClick={getStatusChangeHandler(false)}>
          <Box className={classes.title}>
            <ChatStatusIndicator status={CHAT_STATUS_MAP.UNAVAILABLE} classes={{ root: classes.indicator }} />
            <Typography variant="body1">Unavailable</Typography>
          </Box>
          {status === CHAT_STATUS_MAP.UNAVAILABLE && <CheckIcon />}
        </ListItem>
      </List>
    </Drawer>
  );
};

ChatStatusDrawer.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  open: PropTypes.bool,
  status: PropTypes.bool,
  onStatusChange: PropTypes.func,
  close: PropTypes.func,
};

ChatStatusDrawer.defaultProps = {
  classes: {},
  onStatusChange: () => {},
  close: () => {},
};

export default ChatStatusDrawer;
